import PERMISSIONS from "./permissions";
import { ORGANIZATION } from "./index";
import { showPipelineLogsTab, showVisualisationDashboard } from "./config";
import PipelineLogs from "../pages/grower/pipelineLogs/PipelineLogs";
import { Dashboard } from "../pages/dashboard";
import { Plots } from "../pages/plots";
import { Analysis } from "../pages/analysis";
import { Logs } from "../pages/pollination/logs";
import { GrowerVisualisationDashboard } from "../pages/grower/dashboard";
import GrowerDashboard from "../pages/grower/dashboard/growerDashboard/GrowerDashboard";
import Reports from "../pages/reports/Reports";

const ROUTES = [
  {
    path: "/dashboard",
    component: Dashboard,
    orgTypes: [ORGANIZATION.BREEDER, ORGANIZATION.GROWER],
  },
  {
    path: "/scanning-sessions",
    requiredPermissions: [
      PERMISSIONS.SCANNING_SESSIONS.VIEW,
      PERMISSIONS.SCANNING_SESSIONS.EDIT,
    ],
    componentType: "scanning_sessions",
    component: GrowerDashboard,
    orgTypes: [ORGANIZATION.GROWER],
  },
  {
    path: "/reporting",
    requiredPermissions: [
      PERMISSIONS.REPORTING.VIEW,
      PERMISSIONS.REPORTING.EDIT,
    ],
    componentType: "reporting",
    component: GrowerDashboard,
    orgTypes: [ORGANIZATION.GROWER],
  },
  {
    path: "/reports",
    component: Reports,
    orgTypes: [ORGANIZATION.GROWER],
  },
  {
    path: "/spinach/analysis",
    component: GrowerDashboard,
    componentType: "spinach_analysis",
    orgTypes: [ORGANIZATION.GROWER],
  },
  {
    path: "/spinach/harvest-optimiser",
    component: GrowerDashboard,
    componentType: "spinach_harvest_optimizer",
    orgTypes: [ORGANIZATION.GROWER],
  },
  {
    path: "/broccoli/harvest-optimiser",
    component: GrowerDashboard,
    componentType: "broccoli_harvest_optimizer",
    orgTypes: [ORGANIZATION.GROWER]
  },
  {
    path: "/broccoli/harvest-entry",
    component: GrowerDashboard,
    componentType: "broccoli_harvest_entry",
    orgTypes: [ORGANIZATION.GROWER]
  },
  {
    path: "/spinach/harvest-entry",
    component: GrowerDashboard,
    componentType: "spinach_harvest_entry",
    orgTypes: [ORGANIZATION.GROWER],
  },
  {
    path: "/broccoli/analysis",
    component: GrowerDashboard,
    componentType: "broccoli_analysis",
    orgTypes: [ORGANIZATION.GROWER],
  },
  {
    path: "/plots",
    component: Plots,
    orgTypes: [ORGANIZATION.BREEDER],
  },
  {
    path: "/analysis",
    component: Analysis,
    orgTypes: [ORGANIZATION.BREEDER],
  },
  {
    path: "/logs",
    component: Logs,
    orgTypes: [ORGANIZATION.POLLINATION],
  },
  {
    path: "/visualisation-dashboard",
    component: GrowerVisualisationDashboard,
    orgTypes: [ORGANIZATION.GROWER],
    envAccess: showVisualisationDashboard,
    superuserOnly: true,
  },
  {
    path: "/pipeline-logs",
    component: PipelineLogs,
    orgTypes: [ORGANIZATION.GROWER],
    envAccess: showPipelineLogsTab,
  },
];

export default ROUTES;
